import { mapActions, mapState } from "vuex";
import { showError } from '@/helpers/globalHelpers';

export default {
    name: "AssignUserConfirmDialog",
    data() {
        return {
            addUserConfirmForm: {
                user_confirm: null,
                ticket_id: null,
                description: null
            },
            responsablesRules: [(v) => !!v || 'El usuario es requerido'],
            loadingSave: false,
            listError: [],
        }
    },

    props: {
        value: Boolean,
        item: Object,
    },

    computed: {
        dialog: {
            get() {
                return this.value;
            },
            set(value) {
                this.$emit("input", value);
            },
        },
        ...mapState({
            responsibles: (state) => state.security.usersActive,
        }),
    },

    created() {
        this.getUsersActive()
    },

    methods: {
        ...mapActions('security', ['getUsersActive']),
        // ...mapActions('assetAssign', ['addSignerUserAssetAssign']),
        // ...mapActions('assetAssignment',['addSignerUserAssetAssignment']),

        ...mapActions('ticket',['confirmUser']),
        ...mapActions('ticketComment', [
			'listTicketComments',
		]),

        async getTicketComments() {
			const payload = {
				company_id: this.item.company_id,
				ticket_attention: this.item.ticket_attention.id,
			};
			const { error } = await this.listTicketComments(payload);
            if(error){
                showError(error);
            }
		},

        async addSignerUser() {
            this.loadingSave = true;
            this.addUserConfirmForm.ticket_id = this.item?.id;

            const { error } = await this.confirmUser(this.addUserConfirmForm);

            if (error) showError(error);

            await this.getTicketComments();
            await this.$emit('ticket');

            this.addUserConfirmForm = {
                user_confirm: null,
                ticket_id: null,
                description: null
            }

            this.loadingSave = false;
            this.dialog = false;
        },

        customFilter(item,queryText, itemText) {
			const searchTerms = queryText.toLowerCase().split(' ');
			const fullName = itemText.toLowerCase();

			return searchTerms.every(term => fullName.includes(term));
		},

        close() {
            this.dialog = false;
            (this.addUserConfirmForm = {
                user_confirm: null,
                ticket_id: null,
                description: null
            }),
                (this.listError = []);
            this.$refs?.form?.resetValidation();
        },

    },
};
